import React from 'react';
import {
  Box,
  Paper,
  Typography,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { ResizableTable } from '../../components/resizableTable/ResizableTable';
import SalesForecastCurrentQuarterTable from '../RegionalSalesReviewPackage/SalesForecastCurrentQuarterTable';

const createSummaryTableColumns = () => [
  {
    label: '',
    sortable: false,
    subColumns: [{
      label: '',
      field: 'label',
      type: 'text',
      align: 'left',
      width: 100,
      sortable: false,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: '# of Opps',
    sortable: false,
    subColumns: [{
      label: '# of Opps',
      field: 'count',
      type: 'number',
      align: 'right',
      width: 70,
      sortable: false,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'ACV ($M)',
    sortable: false,
    subColumns: [{
      label: 'ACV ($M)',
      field: 'acvInMillions',
      type: 'number',
      align: 'right',
      width: 70,
      sortable: false,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
];

const createForecastOppsColumns = () => [
  {
    label: '#',
    sortable: false,
    align: 'center',
    subColumns: [{
      label: '#',
      field: 'rowNum',
      type: 'number',
      align: 'left',
      width: 20,
      sortable: false,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Opportunity',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Opportunity',
      field: 'opportunity',
      type: 'text',
      align: 'left',
      width: 115,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Owner',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Owner',
      field: 'owner',
      type: 'text',
      align: 'left',
      width: 40,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Cust. Type',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Cust. Type',
      field: 'Cust_Type',
      type: 'text',
      align: 'left',
      width: 37,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Lead Source',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Lead Source',
      field: 'Lead_Source',
      type: 'text',
      align: 'left',
      width: 37,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'ACV ($K)',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'ACV ($K)',
      field: 'acvInK',
      type: 'number',
      align: 'right',
      width: 35,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Disc. %',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Disc. %',
      field: 'discountPercent',
      type: 'number',
      align: 'left',
      width: 20,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Proj. Close Date',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Proj. Close Date',
      field: 'projectedCloseDate',
      type: 'date',
      align: 'right',
      width: 44,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Age since Qual. (Days)',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Age since Qual. (Days)',
      field: 'ageSinceQualDays',
      type: 'number',
      align: 'right',
      width: 30,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Stage',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Stage',
      field: 'stageChar',
      type: 'text',
      align: 'center',
      width: 25,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Days in Stg.',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Days in Stg.',
      field: 'daysInStage',
      type: 'number',
      align: 'right',
      width: 20,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Forecast Category',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Forecast Category',
      field: 'forecastCategory',
      type: 'text',
      align: 'left',
      width: 50,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Partner',
    sortable: true,
    align: 'center',
    subColumns: [{
      label: 'Partner',
      field: 'partner',
      type: 'text',
      align: 'left',
      width: 70,
      sortable: true,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Risks',
    sortable: false,
    align: 'center',
    subColumns: [{
      label: 'Risks',
      field: 'risks',
      type: 'text',
      align: 'left',
      width: 80,
      sortable: false,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
  {
    label: 'Actions',
    sortable: false,
    align: 'center',
    subColumns: [{
      label: 'Actions',
      field: 'actions',
      type: 'text',
      align: 'left',
      width: 80,
      sortable: false,
      filterable: true,
    }],
    headerBgColor: '#1976d2',
    headerTextColor: '#ffffff',
  },
];

const RegionalRSMSalesForecastSection = ({
  classes,
  salesForecastCurrentQuarterData,
  isSalesForecastCurrentQuarterLoading,
  forecastMovedOutData,
  isForecastMovedOutLoading,
  forecastBestCaseData,
  isForecastBestCaseLoading,
  salesForecastNextQuarterData,
  isSalesForecastNextQuarterLoading,
}) => {
  const salesForecastCurrentQuarter = salesForecastCurrentQuarterData || null;

  const transformOpportunityDataToRows = (opps, includeTotal = false, totalData = null) => {
    const rows =
      opps?.map((opp) => ({
        rowNum: opp.rowNum,
        opportunity: opp.opportunity,
        owner: opp.owner,
        acvInK: opp.acvInK,
        discountPercent: opp.discountPercent != null ? opp.discountPercent : null,
        projectedCloseDate: opp.projectedCloseDate,
        ageSinceQualDays: opp.ageSinceQualDays,
        stageChar: opp.stageChar,
        daysInStage: opp.daysInStage != null ? opp.daysInStage : null,
        partner: opp.partner,
        Cust_Type: opp.Cust_Type || '',
        Lead_Source: opp.Lead_Source || '',
        forecastCategory: opp.forecastCategory,
        nextStep: opp.nextStep,
        isNewThisWeek: opp.isNewThisWeek,
        risks: opp.risks || '',
        actions: opp.actions || '',
        oppId: opp.oppId || opp.Opp_ID || null,
        Opp_ID: opp.Opp_ID || opp.oppId || null,
        label: opp.opportunity || '',
      })) || [];

    if (includeTotal && totalData) {
      rows.push({
        rowNum: null,
        opportunity: `Total (${totalData.totalCount} opps)`,
        owner: null,
        acvInK: totalData.totalACVInK,
        discountPercent: null,
        projectedCloseDate: null,
        ageSinceQualDays: null,
        stageChar: null,
        daysInStage: null,
        partner: null,
        Cust_Type: null,
        Lead_Source: null,
        forecastCategory: null,
        nextStep: null,
        isNewThisWeek: false,
        risks: '',
        actions: '',
        label: 'Total',
      });
    }

    return rows;
  };

  const forecastMovedOutRows = (() => {
    const opps = forecastMovedOutData?.movedOutOpps || [];
    const hasTotals =
      forecastMovedOutData &&
      forecastMovedOutData.totalCount != null &&
      forecastMovedOutData.totalACVInK != null &&
      opps.length > 0;
    const totalData = hasTotals
      ? {
          totalCount: forecastMovedOutData.totalCount,
          totalACVInK: forecastMovedOutData.totalACVInK,
        }
      : null;
    return transformOpportunityDataToRows(opps, !!totalData, totalData);
  })();

  const forecastBestCaseRows = (() => {
    const opps = forecastBestCaseData?.bestCaseOpps || [];
    const hasTotals =
      forecastBestCaseData &&
      forecastBestCaseData.totalCount != null &&
      forecastBestCaseData.totalACVInK != null &&
      opps.length > 0;
    const totalData = hasTotals
      ? {
          totalCount: forecastBestCaseData.totalCount,
          totalACVInK: forecastBestCaseData.totalACVInK,
        }
      : null;
    return transformOpportunityDataToRows(opps, !!totalData, totalData);
  })();

  const salesForecastNextQuarterSummaryRows = [
    {
      label: 'Won QTD',
      count: salesForecastNextQuarterData?.summary?.won?.count || 0,
      acvInMillions:
        salesForecastNextQuarterData?.summary?.won?.acvInMillions || '0.00',
      rowType: 'won',
    },
    {
      label: 'Most Likely + Commit',
      count: salesForecastNextQuarterData?.summary?.forecast?.count || 0,
      acvInMillions:
        salesForecastNextQuarterData?.summary?.forecast?.acvInMillions ||
        '0.00',
      rowType: 'forecast',
    },
    {
      label: 'Total Forecast',
      count: salesForecastNextQuarterData?.summary?.total?.count || 0,
      acvInMillions:
        salesForecastNextQuarterData?.summary?.total?.acvInMillions || '0.00',
      rowType: 'total',
    },
    {
      label: 'Forecast Goal (1.5x Quota)',
      count: '',
      acvInMillions:
        salesForecastNextQuarterData?.summary?.forecastGoal || '0.00',
      rowType: 'forecast',
    },
    {
      label: 'Quota',
      count: '',
      acvInMillions:
        salesForecastNextQuarterData?.summary?.quotaInMillions || '0.00',
      rowType: 'quota',
    },
  ];

  const salesForecastNextQuarterRows = (() => {
    const opps =
      salesForecastNextQuarterData?.forecastOpps?.slice(0, 15) || [];
    const rows = transformOpportunityDataToRows(opps);

    if (salesForecastNextQuarterData?.forecastOpps?.length > 15) {
      const otherOpps = salesForecastNextQuarterData.forecastOpps.slice(15);
      const otherOppsTotal = otherOpps.reduce(
        (sum, opp) => sum + parseFloat(opp.acvInK || 0),
        0
      );
      rows.push({
        rowNum: null,
        opportunity: `Other Opps (${otherOpps.length})`,
        owner: null,
        acvInK: otherOppsTotal,
        discountPercent: null,
        projectedCloseDate: null,
        ageSinceQualDays: null,
        stageChar: null,
        daysInStage: null,
        partner: null,
        Lead_Source: null,
        forecastCategory: null,
        nextStep: null,
        isNewThisWeek: false,
        risks: '',
        actions: '',
        label: 'Other Opps',
      });
    }

    if (salesForecastNextQuarterData?.forecastOpps?.length > 0) {
      rows.push({
        rowNum: null,
        opportunity: `Total (${salesForecastNextQuarterData.totalCount} opps)`,
        owner: null,
        acvInK: salesForecastNextQuarterData.totalACVInK,
        discountPercent: null,
        projectedCloseDate: null,
        ageSinceQualDays: null,
        stageChar: null,
        daysInStage: null,
        partner: null,
        Lead_Source: null,
        forecastCategory: null,
        nextStep: null,
        isNewThisWeek: false,
        risks: '',
        actions: '',
        label: 'Total',
      });
    }

    if (salesForecastNextQuarterData?.quota > 0) {
      rows.push({
        rowNum: null,
        opportunity: 'Quota',
        owner: null,
        acvInK: salesForecastNextQuarterData.quota / 1000,
        discountPercent: null,
        projectedCloseDate: null,
        ageSinceQualDays: null,
        stageChar: null,
        daysInStage: null,
        partner: null,
        Lead_Source: null,
        forecastCategory: null,
        nextStep: null,
        isNewThisWeek: false,
        risks: '',
        actions: '',
        label: 'Quota',
      });
    }

    return rows;
  })();

  return (
    <>
      <SalesForecastCurrentQuarterTable
        classes={classes}
        data={salesForecastCurrentQuarter}
        isLoading={isSalesForecastCurrentQuarterLoading}
        asOfDateLabel=""
        handleChangeLocation={() => {}}
      />

      <Box mt={4}>
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Typography variant="h6" className={classes.title}>
              Sales Forecast – Current Quarter – Forecast – Most Likely + Commit Opps moved out in the last week
            </Typography>
            <span className={classes.updateFrequency}>
              {'Live Data'}
            </span>
          </Box>

          {isForecastMovedOutLoading ? (
            <Skeleton variant="rect" animation="wave" height={200} width="100%" />
          ) : (
            <>
              {forecastMovedOutRows.length === 0 ? (
                <Box textAlign="center" py={4} style={{ fontStyle: 'italic', color: '#666' }}>
                  No forecast opps moved out this week
                </Box>
              ) : (
                <ResizableTable
                  columns={createForecastOppsColumns()}
                  rows={forecastMovedOutRows}
                  getCellValue={(row, field) => {
                    if (field === 'rowNum') {
                      return row.rowNum || '';
                    }
                    return row[field] != null ? row[field] : '';
                  }}
                  getCellStyle={(row) => {
                    if (row.isNewThisWeek) {
                      return { backgroundColor: '#c8e6c9' };
                    }
                    return {};
                  }}
                  rowKey="label"
                  hideSubHeaderRow={true}
                  maxWidth="100%"
                  onRowClick={() => {}}
                />
              )}
            </>
          )}
        </Paper>
      </Box>

      <Box mt={4}>
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Typography variant="h6" className={classes.title}>
              {'Current Quarter – Best Case'}
            </Typography>
            <span className={classes.updateFrequency}>
              {'Live Data'}
            </span>
          </Box>

          {isForecastBestCaseLoading ? (
            <Skeleton variant="rect" animation="wave" height={200} width="100%" />
          ) : (
            <>
              {forecastBestCaseRows.length === 0 ? (
                <Box textAlign="center" py={4} style={{ fontStyle: 'italic', color: '#666' }}>
                  No best case opps found
                </Box>
              ) : (
                <ResizableTable
                  columns={createForecastOppsColumns()}
                  rows={forecastBestCaseRows}
                  getCellValue={(row, field) => {
                    if (field === 'rowNum') {
                      return row.rowNum || '';
                    }
                    return row[field] != null ? row[field] : '';
                  }}
                  getCellStyle={(row) => {
                    if (row.isNewThisWeek) {
                      return { backgroundColor: '#c8e6c9' };
                    }
                    return {};
                  }}
                  rowKey="label"
                  hideSubHeaderRow={true}
                  maxWidth="100%"
                  onRowClick={() => {}}
                />
              )}
            </>
          )}
        </Paper>
      </Box>

      <Box mt={4}>
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Typography variant="h6" className={classes.title}>
              {'Sales Forecast – Next Quarter'}
              {salesForecastNextQuarterData?.targetQuarter
                ? ` (${salesForecastNextQuarterData.targetQuarter})`
                : ''}
            </Typography>
            <span className={classes.updateFrequency}>
              {'Live Data'}
            </span>
          </Box>

          {isSalesForecastNextQuarterLoading ? (
            <Skeleton variant="rect" animation="wave" height={200} width="100%" />
          ) : (
            <>
              <Box mb={3}>
                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                  Summary
                </Typography>
                <ResizableTable
                  columns={createSummaryTableColumns()}
                  rows={salesForecastNextQuarterSummaryRows}
                  getCellValue={(row, field) => {
                    if (field === 'label') {
                      return row[field];
                    }
                    return row[field] != null ? row[field] : '';
                  }}
                  getCellStyle={(row, field) => {
                    const baseStyle = {};
                    if (field === 'label') {
                      baseStyle.fontWeight = 600;
                    }
                    if (row.rowType === 'total') {
                      baseStyle.backgroundColor = '#f5f5f5';
                      if (field === 'count' || field === 'acvInMillions') {
                        baseStyle.fontWeight = 600;
                      }
                    }
                    if (row.rowType === 'quota') {
                      baseStyle.backgroundColor = '#fff9c4';
                      if (field === 'acvInMillions') {
                        baseStyle.fontWeight = 600;
                      }
                    }
                    return baseStyle;
                  }}
                  rowKey="label"
                  hideSubHeaderRow={true}
                  maxWidth="34%"
                />
              </Box>

              <Box mb={3}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginTop: 70 }}>
                  {'Sales Forecast – Next Quarter'}
                  {salesForecastNextQuarterData?.targetQuarter
                    ? ` (${salesForecastNextQuarterData.targetQuarter})`
                    : ''}
                  {' – Opps in Forecast – Most Likely + Commit'}
                </Typography>
                {salesForecastNextQuarterRows.length === 0 ? (
                  <Box textAlign="center" py={4} style={{ fontStyle: 'italic', color: '#666' }}>
                    No forecast opportunities for next quarter
                  </Box>
                ) : (
                  <ResizableTable
                    columns={createForecastOppsColumns()}
                    rows={salesForecastNextQuarterRows}
                    getCellValue={(row, field) => {
                      if (field === 'rowNum') {
                        return row.rowNum || '';
                      }
                      return row[field] != null ? row[field] : '';
                    }}
                    getCellStyle={(row) => {
                      if (row.label === 'Total' || row.label === 'Quota') {
                        return {
                          fontWeight: 600,
                          backgroundColor: row.label === 'Quota' ? '#fff9c4' : '#f5f5f5',
                        };
                      }
                      if (row.isNewThisWeek) {
                        return { backgroundColor: '#c8e6c9' };
                      }
                      return {};
                    }}
                    rowKey="label"
                    hideSubHeaderRow={true}
                    maxWidth="100%"
                    onRowClick={() => {}}
                  />
                )}
              </Box>

              <Box mt={2}>
                <div className={classes.legend}>
                  <div className={classes.legendItem}>
                    <div className={classes.legendBox} style={{ backgroundColor: '#c8e6c9' }} />
                    <Typography variant="body2">New this week</Typography>
                  </div>
                </div>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </>
  );
};

export default RegionalRSMSalesForecastSection;
